import { CoverageScreenType } from './coverage-type';

export const CoverageScreenShowPreferredPartnersForm = {
  contactUs: false,
  limited100Covered: true,
  manufacturerCovered: false, // Google Query for [Make] Service
  carvanaCareCovered: true,
  carvanaCareOilTireCovered: true,
  thirtyDayCovered: true,
  conditionallyCoveredBrakes: true,
  notCovered: true,
  notCoveredCosmetic: true,
  notCoveredGlass: false, // static Safelite Result
  notCoveredAdditionalCosmetic: true,
  notCoveredAdditionalKey: false, // static CarKeysExpress result
  notCoveredMissingAccessories: false, // Visit [Make] Website
  cosmeticSubmitted: false,
  carvanaCareRoadHazardCovered: true,
  carvanaCareRoadHazardNotCovered: true,
  carvanaCareOilChangeCovered: true,
  carvanaCareOilChangeNotCovered: true,
  carvanaCareDentCovered: true,
};

export const showPreferredPartnersForm = (coverageScreenType: CoverageScreenType): boolean => {
  return CoverageScreenShowPreferredPartnersForm[coverageScreenType];
};
